import {useEffect, useState} from 'react';

export const useColumnResizeObserver = (
  leftColRef: React.RefObject<HTMLDivElement | null>,
  rightColRef: React.RefObject<HTMLDivElement | null>
) => {
  const [computedLeftWidth, seComputedLeftWidth] = useState(0);
  const [computedRightWidth, seComputedRightWidth] = useState(0);
  // Vertical Resize between panels inside sections event handlers
  useEffect(() => {
    if (!leftColRef?.current) {
      return;
    }
    const observer = new ResizeObserver(([entry]) => {
      seComputedLeftWidth(entry.contentRect.width);
    });
    observer.observe(leftColRef.current);
    return () => observer.disconnect();
  }, [leftColRef]);

  useEffect(() => {
    if (!rightColRef?.current) {
      return;
    }
    const observer = new ResizeObserver(([entry]) => {
      seComputedRightWidth(entry.contentRect.width);
    });
    observer.observe(rightColRef.current);
    return () => observer.disconnect();
  }, [rightColRef]);

  return {computedLeftWidth, computedRightWidth};
};
